var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"custom-aside"},[_c('SectionAside',{attrs:{"text":"Dashboard","icon":_vm.iconBock}}),_vm._v(" "),_c('SectionAside',{attrs:{"text":"Clientes potenciais","icon":_vm.iconUserPlus}}),_vm._v(" "),_c('SectionAside',{attrs:{"text":"Negócios","icon":_vm.iconBriefcase}}),_vm._v(" "),_c('ButtonToHide',{})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bbcacd7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Aside/index.vue
// module id = null
// module chunks = 